









































































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";
import { RegisterInfo } from "../user/UserApi";

import { MerchantRaffleInfo } from "../merchant/MerchantApi";
import vueQr from "vue-qr";
Vue.use(vueQr);
declare const $: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Image.name]: Image,
  },
})
export default class YhfflToChoose extends mixins(WeMixin, Jssdk) {
  private chooseDialog: boolean = false;
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private merchantRaffleInfo: MerchantRaffleInfo = {} as MerchantRaffleInfo;
  private showAddress: boolean = false;
  private orgname: string = "";
  private orgphone: string = "";
  private jjktype: string = "";
  private showqrcode: boolean = false;
  private showaddress: boolean = false;
  private qrCodeText: string = "";

  private jjktypelist: any[] = [
    { key: "1", value: "实体卡" },
    { key: "2", value: "实体二类卡" },
  ];

  protected created() {
    this.chooseDialog = true;

    this.initWx().then((wjs: WxJsapiSignature) => {
      this.$wx.config({
        debug: wjs.debug, // wjs.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wjs.appId, // 必填，公众号的唯一标识
        timestamp: wjs.timestamp, // 必填，生成签名的时间戳
        nonceStr: wjs.nonceStr, // 必填，生成签名的随机串
        signature: wjs.signature, // 必填，签名
        jsApiList: ["openLocation"], // 必填，需要使用的JS接口列表
      });
    });
  }

  protected createShow() {
    console.log(this.jjktype);
    if (this.jjktype === "") {
      this.$toast("请选择借记卡类型");
      return;
    } else {
      if (this.jjktype === "1") {
        this.chooseDialog = false;
        this.showqrcode = false;
        this.showaddress = true;
        this.getOrgAdress();
      } else if (this.jjktype === "2") {
        this.chooseDialog = false;
        this.showqrcode = true;
        this.showaddress = false;
        this.qrCodeText =
          "https://wap.psbc.com/mobilebank/weixinRecordOfReferences.do?type=03&custId=790697809&openOrg=32019537&newqrcodeflag=1";
      }
    }
  }

  protected getOrgAdress() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        this.registerInfo = res.data;
        api
          .post("/weixinmp/xsyx/yhffl/getYhfflAdress", this.registerInfo)
          .then((res1: any) => {
            console.log(res1);
            if (res1.data.flag) {
              console.log(111);
              $(".mask-black,#zj-modal").css("display", "block");
              this.orgname = res1.data.orgname;
              this.orgphone = res1.data.orgphone;
            } else {
              $(".mask-black,#no-modal").css("display", "block");
            }
          });
      } else if (res.data.flag === "1") {
        $(".mask-black,#no-modal").css("display", "block");
      }
    });
  }

  protected toNavigation() {
    this.merchantRaffleInfo.orgid = this.registerInfo.orgid;
    console.log(this.merchantRaffleInfo.orgid);
    api
      .post(
        "/weixinmp/xsyx/merchant/getMerchantRaffleInfo2",
        this.merchantRaffleInfo
      )
      .then((res: any) => {
        if (res.data.awardingaddress == "没有该地址的经纬度信息") {
          this.$toast(res.data.awardingaddress);
          return;
        }
        if (!this.$wxReady) {
          return;
        }
        this.$wx.openLocation({
          latitude: parseFloat(res.data.lat),
          longitude: parseFloat(res.data.lng),
          name: res.data.awardingaddress,
          scale: 28,
        });
      });
  }
}
